export interface OsiService {
  osiId: number | null;
  osiInfo: any;
  osiDocs: any;
  osiMenus: Record<string, { active: boolean } & Record<string, any>>;
  isLoading: boolean;
  isLockedMenus: boolean;

  // OSI-806: завершилась ли гидратация persist-стора (osiId восстанавливается асинхронно).
  // Нужен гварду раздела /osi, чтобы не принять «дом не выбран» до окончания гидратации.
  readonly isStoreHydrated: boolean;

  readonly menuItems: any[];
  readonly isWizardFinished: boolean;
  readonly isFreeMode: boolean;

  hydrateOsi(): Promise<void>;

  selectOsi(osiId: number, withRedirect?: boolean): Promise<void>;

  refreshOsi(): Promise<void>;

  exitOsi(): void;

  loadOsiInfo(): Promise<void>;

  loadOsiDocs(): Promise<void>;

  loadOsiMenus(): Promise<void>;

  activatePartialMenus(): void;

  activateAllMenus(): void;

  // Сброс полей к initial + очистка persist сессии (иначе выбранный ОСИ протекает между входами)
  clearSession(): Promise<void>;
}

export const OsiServiceIdentifier = Symbol.for('OsiService');
